import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import Datepicker from '../Datepicker';
import FormError from '../Form/FormError';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function DatePickerFormFieldComponent(_ref) {
  var _props$labels, _props$labels2, _props$labels3, _props$labels4, _props$labels5, _props$labels6;
  var field = _ref.field,
    handleSetValue = _ref.handleSetValue,
    _ref$errors = _ref.errors,
    errors = _ref$errors === void 0 ? {} : _ref$errors,
    _ref$formField = _ref.formField,
    props = _ref$formField.props,
    errorStyles = _ref$formField.errorStyles;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isError = _useState2[0],
    setIsError = _useState2[1];
  useEffect(() => {
    setIsError(!!errors[field.name]);
  }, [errors[field.name]]);
  return _jsxs(_Fragment, {
    children: [_jsx(Datepicker, {
      locale: props === null || props === void 0 ? void 0 : props.locale,
      minDate: new Date(),
      datepickerStyles: datepickerStyles,
      dateFormat: 'dd MMM yyyy',
      displayDateFormat: "dd MMM yyyy",
      selectsRange: true,
      labels: {
        resetButtonLabel: props === null || props === void 0 || (_props$labels = props.labels) === null || _props$labels === void 0 ? void 0 : _props$labels.resetButtonLabel,
        doneButtonLabel: props === null || props === void 0 || (_props$labels2 = props.labels) === null || _props$labels2 === void 0 ? void 0 : _props$labels2.doneButtonLabel,
        todayLabel: props === null || props === void 0 || (_props$labels3 = props.labels) === null || _props$labels3 === void 0 ? void 0 : _props$labels3.todayLabel,
        tomorrowLabel: props === null || props === void 0 || (_props$labels4 = props.labels) === null || _props$labels4 === void 0 ? void 0 : _props$labels4.tomorrowLabel,
        checkoutLabel: props === null || props === void 0 || (_props$labels5 = props.labels) === null || _props$labels5 === void 0 ? void 0 : _props$labels5.checkoutLabel,
        checkInLabel: props === null || props === void 0 || (_props$labels6 = props.labels) === null || _props$labels6 === void 0 ? void 0 : _props$labels6.checkInLabel
      },
      hasFooter: true,
      onSelectDates: value => handleSetValue === null || handleSetValue === void 0 ? void 0 : handleSetValue(field.name, value),
      displayDatesNotification: true,
      onReset: () => handleSetValue === null || handleSetValue === void 0 ? void 0 : handleSetValue(field.name, []),
      onDone: value => value.includes(null) ? setIsError(true) : setIsError(false)
    }), isError && _jsx(FormError, {
      errors: errors,
      name: field.name,
      extraStyles: errorStyles
    })]
  });
}
var inputGroupStyles = {
  w: 'full',
  h: 'var(--chakra-space-4xl)',
  border: {
    base: '1px solid var(--chakra-colors-lightGrey1)',
    sm: 0
  },
  borderRadius: {
    base: 'var(--chakra-space-xs)',
    sm: 0
  }
};
var bookingDatepickerSize = {
  w: {
    base: '49%',
    sm: 'full',
    lg: '19.5rem',
    xl: '19.781rem'
  }
};
var datepickerInputElementStyles = {
  h: '100%',
  w: '100%',
  flex: {
    base: '1 1 50%',
    sm: '1 1 auto'
  },
  mr: '0',
  _placeholder: {
    color: 'var(--chakra-colors-darkGrey1)'
  },
  borderRight: '0.063rem solid var(--chakra-colors-lightGrey1)',
  border: '0.063rem solid var(--chakra-colors-lightGrey1)',
  borderRadius: 'var(--chakra-space-xs)',
  borderColor: 'var(--chakra-colors-lightGrey1)',
  borderTopRightRadius: 'var(--chakra-space-xs)',
  borderBottomRightRadius: 'var(--chakra-space-xs)'
};
var iconStyles = {
  top: 'var(--chakra-space-sm)'
};
var datepickerStyles = {
  inputGroupStyles,
  bookingDatepickerSize,
  datepickerInputElementStyles,
  iconStyles
};